import React from 'react';
import { Row, Col, Card, Statistic } from 'antd';
import { ArrowUpOutlined, ArrowDownOutlined, DatabaseOutlined, BoxPlotOutlined, CalculatorOutlined } from '@ant-design/icons';

const KpiCards = ({ data, loading }) => {
  if (!data) {
    return null;
  }

  const getGrowthColor = (growth) => {
    if (growth > 0) return '#3f8600';
    if (growth < 0) return '#cf1322';
    return '#666666';
  };

  const getGrowthIcon = (growth) => {
    if (growth > 0) return <ArrowUpOutlined />;
    if (growth < 0) return <ArrowDownOutlined />;
    return null;
  };

  return (
    <Row gutter={16}>
      <Col xs={24} sm={12} md={6}>
        <Card loading={loading}>
          <Statistic
            title="Total de Lotes"
            value={data.totalBatches}
            precision={0}
            valueStyle={{ color: '#1890ff' }}
            prefix={<DatabaseOutlined />}
            suffix={
              data.batchesGrowth !== 0 && (
                <span style={{ fontSize: 14, color: getGrowthColor(data.batchesGrowth) }}>
                  {getGrowthIcon(data.batchesGrowth)} {Math.abs(data.batchesGrowth)}%
                </span>
              )
            }
          />
          <div style={{ marginTop: 8, fontSize: 12, color: '#999' }}>
            vs. período anterior
          </div>
        </Card>
      </Col>

      <Col xs={24} sm={12} md={6}>
        <Card loading={loading}>
          <Statistic
            title="Total de Tambores"
            value={data.totalDrums}
            precision={0}
            valueStyle={{ color: '#52c41a' }}
            prefix={<BoxPlotOutlined />}
            suffix={
              data.drumsGrowth !== 0 && (
                <span style={{ fontSize: 14, color: getGrowthColor(data.drumsGrowth) }}>
                  {getGrowthIcon(data.drumsGrowth)} {Math.abs(data.drumsGrowth)}%
                </span>
              )
            }
          />
          <div style={{ marginTop: 8, fontSize: 12, color: '#999' }}>
            vs. período anterior
          </div>
        </Card>
      </Col>

      <Col xs={24} sm={12} md={6}>
        <Card loading={loading}>
          <Statistic
            title="Média de Tambores"
            value={data.avgDrums}
            precision={1}
            valueStyle={{ color: '#fa8c16' }}
            prefix={<CalculatorOutlined />}
            suffix="por lote"
          />
          <div style={{ marginTop: 8, fontSize: 12, color: '#999' }}>
            no período selecionado
          </div>
        </Card>
      </Col>

      <Col xs={24} sm={12} md={6}>
        <Card loading={loading}>
          <Statistic
            title="Crescimento"
            value={data.batchesGrowth}
            precision={1}
            valueStyle={{ color: getGrowthColor(data.batchesGrowth) }}
            prefix={getGrowthIcon(data.batchesGrowth)}
            suffix="%"
          />
          <div style={{ marginTop: 8, fontSize: 12, color: '#999' }}>
            lotes vs. período anterior
          </div>
        </Card>
      </Col>
    </Row>
  );
};

export default KpiCards;

